<ng-container content>
    <div class="list-container">
        <checklist-table-new
            [checklists]="organizationChecklists$ | async"
            (onEditChecklist)="onEditChecklist($event)"
            (onCopyChecklist)="onCopyChecklist($event)"
            (onDeleteChecklist)="onDeleteChecklist($event)"
            (addNewChecklistClicked)="onAddNewChecklistClicked()"
        ></checklist-table-new>
    </div>
</ng-container>
